import type { PlanResult } from "@decopl/deco-engine";
import { ZHL16C, gfMValueAtDepth, tissueAnalogy } from "@decopl/deco-engine";
import { useStore } from "../store.js";

interface Props {
  result: PlanResult | null;
}

export function TissueLoadingChart({ result }: Props) {
  const { gfHigh, lang } = useStore();
  if (!result) return null;
  const tissues = result.finalTissues.pN2;
  const gf = gfHigh / 100;

  const cells = tissues.map((p, i) => {
    const cpt = ZHL16C[i]!;
    const mGF = gfMValueAtDepth(0, cpt.aN2, cpt.bN2, gf);
    const sat = (p / mGF) * 100;
    const ana = tissueAnalogy(cpt.halfTimeN2);
    return { i, ht: cpt.halfTimeN2, p, mGF, sat, ana };
  });

  return (
    <div className="tissue-grid">
      {cells.map((c) => {
        const label = lang === "fr" ? c.ana.shortFR : c.ana.shortEN;
        const fullLabel = lang === "fr" ? c.ana.fullFR : c.ana.fullEN;
        return (
          <div
            key={c.i}
            className={`tissue-cell${c.sat > 100 ? " over" : ""}`}
            title={`#${c.i + 1} · t½ ${c.ht}min · ${fullLabel} · pN₂ ${c.p.toFixed(2)}/${c.mGF.toFixed(2)} bar`}
          >
            <div
              className="tissue-fill"
              style={{ height: `${Math.min(120, c.sat)}%` }}
            />
            <div className="num">
              #{String(c.i + 1).padStart(2, "0")} · {label}
            </div>
            <div>
              <div className="ht">{c.ht}'</div>
              <div className="pct">{c.sat.toFixed(0)}%</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
